import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CustomModal } from '../../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import useModalFotosOcorrencias, { LOAD_MESSAGE } from './ModalFotosOcorrenciasHook'
import { FaTrash } from 'react-icons/fa'

function ModalFotosOcorrencias({
  dispatch,
  data,
  show,
  onModalClose,
  selectedPicking,
  urlFoto,
  onDelete,
}) {
  const { state, localDispatch } = useModalFotosOcorrencias()

  useEffect(() => {
    if (show) localDispatch.onInit(data.fotos)
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Fotos Ocorrências"
      isVisible={show}
      onClose={onModalClose}
      style={{ maxHeight: '90vh', maxWidth: '70vw', overflowY: 'scroll', backgroundColor: 'white' }}
    >
      {state.fotos.map((foto, index) => (
        <div
          key={index}
          style={{
            border: 'solid 1px gray',
            marginBottom: 10,
          }}
        >
          <div style={{ textAlign: 'end' }}>
            <FaTrash
              style={{ cursor: 'pointer' }}
              color="red"
              size={30}
              onClick={async () => {
                await onDelete(foto, selectedPicking)
                localDispatch.delete(foto)
              }}
            />
          </div>
          <img
            src={urlFoto(foto.url_image)}
            alt={'Foto Ocorrência'}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        </div>
      ))}
      {(!state.fotos || !state.fotos.length) && <div>Nenhuma foto anexada</div>}
    </CustomModal>
  )
}
export default connect()(ModalFotosOcorrencias)
